var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen overflow-auto",attrs:{"id":"MainContainer"}},[_c('Header'),_c('Nav',{staticClass:"md:hidden",attrs:{"menu-list-item":_vm.menuListItems,"user":_vm.user}}),_c('router-view',{staticClass:"min-h-full"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }